import { DirectionsCar } from "@mui/icons-material"

export const DirectionsCarFitIcon = (props) => {
    return <DirectionsCar viewBox="3 4 18 17" {...props} />
}

DirectionsCarFitIcon.propTypes = DirectionsCar.propTypes